export default "/images/FG.png?7b3d4cbe909f56c649c8740a811b9791";